import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  Input,
  FormInstance,
  Cascader,
  TreeSelect,
  Spin,
  Space,
  Button,
  Row,
  Col,
  Upload,
  notification,
  Select
} from "antd";
import { getOrgsOptionsSelector } from "@redux/selector";
import { useDispatch, useSelector, useStore } from "react-redux";
import {
  getTagList
} from "../../axios/api.account";

import { isTypeNode } from "typescript";

import { useTranslation } from "react-i18next";

const { Item, List } = Form;
interface propsModel {
    appId: string;
    onLoad(ref:any): void;
}

export const PushAppForm = (props: propsModel) => {
  const appId = props.appId;
  const { onLoad } = props;
  let orgOptions=  useSelector(getOrgsOptionsSelector);
  const [tagList,setTagList]  =useState<any[]>();
  const [selectTags,setSelectTags]  =useState<any[]>();
  const [orgId,setOrgId]  =useState<any[]>();
  const [scopeType,setScopeType]  =useState<any>("All");

  const { t } = useTranslation();

  function handleChange(value:any[]){
    console.log(value);
    setSelectTags(value);  
    updateDataInfo({
      organizationId:orgId,
      tags:value,
      scopeType:scopeType,
    });
  }
  function scopeChange(value:any[]){
    console.log(value);
    setScopeType(value);
    updateDataInfo({
      organizationId:orgId,
      tags:selectTags,
      scopeType:value,
    });
  }
  function updateDataInfo(obj:any){
    onLoad(obj)
  }
  useEffect(()=>{
    getTagList().then((res) => {
      var arr =[];
      arr=res;
      var options=[];
   
      for(var i=0;i<arr.length;i++){
        if(arr[i].values){
          for(var j=0;j<arr[i].values.length;j++){
            options.push(arr[i].values[j])
          }
        }
      }
      setTagList(options);
    });
  }, [])
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <>
      <Spin spinning={loading}>
          {/* <Item label={t("选择部门")}>
            <TreeSelect
              placeholder={t("全部")}
              value={orgId}
              treeData={orgOptions}
              treeDefaultExpandAll
              onChange={(v) =>{
                setOrgId(v);
                updateDataInfo({
                  organizationId:v,
                  tags:selectTags,
                });
              } }
            ></TreeSelect>
          </Item> */}
          <Item label={t("推送范围")} labelCol={{span:4}}>
            <Select
                value={scopeType}
                onChange={scopeChange}
                placeholder={t("推送范围")}
              >
                <Select.Option value="All">{t("全部")}</Select.Option>
                <Select.Option value="DeviceGroup">{t("设备组")}</Select.Option>
              </Select>
          </Item>
          { scopeType == "DeviceGroup" &&
            <Item label={t("请选择设备组")} labelCol={{span:4}}>
              <Select
                mode="multiple"
                placeholder={t("请选择设备组")}
                onChange={handleChange}
                optionLabelProp="label">
                {
                  Array.isArray(tagList)? 
                  tagList.map(item => (
                    <Select.Option key={item.id}  value={item.id} label={item.value}>{item.value}</Select.Option >
                  )):""
                }
              </Select>
            </Item>
          }
      </Spin>
    </>
  );
};
